import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actionCreators from '../actions';

class BreadCrumbs extends Component {
	constructor(props) {
		super(props);

		this.handleLinkClick = this.handleLinkClick.bind(this);
	}

	handleLinkClick(path, e) {
		e.preventDefault();
		const {dispatch} = this.props;
		dispatch(push(path));
	}

	getCrumbClass(curIndex, itemCount) {
		let i = curIndex + 1;
		if (i === itemCount){
			return 'CrumbArticle';
		}else if(i === itemCount-1){
			return 'CrumbParent';
		}else{
			return `CrumbLvl${curIndex}`;
		}
	}

	render() {
		const {listItems, expandedListItems, activeListItem} = this.props;
		const expandedListItemsReverse = expandedListItems.slice(0).reverse();
		if (!expandedListItemsReverse.includes(activeListItem)){
			expandedListItemsReverse.push(activeListItem); // for leafs
		}
		return (
			<ul className="BreadCrumb">
				{expandedListItemsReverse.map((index, i) =>
						<li key={listItems[index].articleKey} className={this.getCrumbClass(i, expandedListItemsReverse.length)}>
							<span onClick={(e) => this.handleLinkClick(`/book/${listItems[expandedListItemsReverse[0]].articleKey}/article/${listItems[index].articleKey}`, e)}>{listItems[index].title}</span>
						</li>
				)}
			</ul>
		)
	}
}

BreadCrumbs.PropTypes = {
	listItems : PropTypes.array.isRequired,
	expandedListItems: PropTypes.array.isRequired,
	activeListItem: PropTypes.number
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapDispatchToProps)(BreadCrumbs);



// WEBPACK FOOTER //
// ./src/components/BreadCrumbs.js